<template>
    <div class="animated fadeIn">
        <component-new-header
            title="History"
            :isLoading="loading"
            @reload-data="$apollo.queries.execution.refetch()"
            @back-press="$router.push('/setup/workflows')"
            :hasCreate="false"
            :hasback="true"
            :hasDropdown="false"
            :has-search="false"
        >
        </component-new-header>
        <b-card class="card-wrap" border-variant="info">
            <b-tabs v-model="historyTabs">
                <b-tab title="Execution History">
                    <b-table
                        :items="execution"
                        :fields="columns.execution"
                        :per-page="executionPagination.perPage"
                        :current-page="executionPagination.currentPage"
                        :busy="loading"
                        :hover="true"
                        :dark="false"
                        :striped="false"
                        :bordered="false"
                        :small="false"
                        :fixed="false"
                    >
                        <template slot="cell(startTime)" slot-scope="data">
                            <span>{{
                                new Date(
                                    data.item.startTime,
                                ).toLocaleDateString()
                            }}</span>
                        </template>
                        <template slot="cell(endTime)" slot-scope="data">
                            <span>{{
                                new Date(data.item.endTime).toLocaleDateString()
                            }}</span>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <b-button
                                    size="sm"
                                    class="button-circle mr-2"
                                    variant="primary"
                                    @click="
                                        $router.push(
                                            '/setup/workflows/history/' +
                                                data.item.workflowId,
                                        )
                                    "
                                >
                                    <i class="fa fa-eye"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </b-tab>
                <!-- api non functional add after sorting out in atlas -->
                <!-- <b-tab title="Workflow History"> Workflow History</b-tab> -->
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import gql from "graphql-tag";
import ComponentNewHeader from "@/components/componentNewHeader/index.vue";

export default {
    components: { ComponentNewHeader },
    data() {
        return {
            historyTabs: 0,
            workflow: [],
            execution: [],
            executionPagination: {
                currentPage: 1,
                perPage: 10,
                total: 0,
            },
            workflowPagination: {
                currentPage: 1,
                perPage: 10,
                total: 0,
            },
            loading: false,
            columns: {
                execution: [
                    {
                        key: "workflowType",
                        label: "Name",
                    },
                    {
                        key: "version",
                    },
                    {
                        key: "workflowId",
                        label: "Workflow Id",
                    },
                    {
                        key: "status",
                    },
                    {
                        key: "startTime",
                    },
                    {
                        key: "endTime",
                    },
                    {
                        key: "action",
                    },
                ],
                workflow: [],
            },
        };
    },
    methods: {
        createWorkflow() {},
    },
    apollo: {
        execution: {
            query: gql`
                query getExecutions(
                    $size: Int
                    $start: Int
                    $freeText: String
                    $query: String
                    $sort: String
                ) {
                    getExecutionList(
                        size: $size
                        start: $start
                        freeText: $freeText
                        query: $query
                        sort: $sort
                    ) {
                        results {
                            workflowId
                            workflowType
                            version
                            status
                            startTime
                            endTime
                            executionTime
                        }
                        totalHits
                    }
                }
            `,
            variables: {
                sort: "startTime:DESC",
            },
            update: (data) => data.getExecutionList.results || [],
            result({ data }) {
                this.executionPagination.total =
                    data.getExecutionList.totalHits;
            },
        },
        workflow: {
            query: gql`
                query allWorkflowHistory {
                    allWorkflowHistory
                }
            `,
            update: (data) => data.allWorkflowHistory || [],
            result({ data }) {
                this.workflowPagination.total = (
                    data.allWorkflowHistory || []
                ).length;
            },
        },
    },
};
</script>
